/* global SENTRY_CONFIG:false */
/* global RELEASE_SHA:false */
import '../../stylesheets/common/index.less';
import angular from 'angular';
import Raven from 'raven-js';
import ngRaven from 'raven-js/plugins/angular';


const modules = [
  require('angular-animate'),
  require('angular-moment'),
  require('angular-timer'),
  require('angular-touch'),
  require('./components'),
  require('./controllers'),
  require('./directives'),
  require('./filters'),
  require('./models'),
  require('./services'),
  require('./values'),
  require('./routes'),
];

const RAVEN_URL =
  window.odDeployType === 'admin' ?
    (SENTRY_CONFIG[window.odRailsEnv] || {}).admin_frontend :
    (SENTRY_CONFIG[window.odRailsEnv] || {}).web_frontend;

if (RAVEN_URL) {
  const ignoreErrors = [];
  if (navigator.userAgent.match('CriOS')) {
    // Error generated by a bug in auto-fill library from Chrome Mobile on iOS
    // https://github.com/getsentry/sentry/issues/5267
    ignoreErrors.push(/Blocked a frame with origin/);
  }

  Raven
    .config(RAVEN_URL, {
      ignoreErrors: ignoreErrors,
      environment: window.odRailsEnv,
      shouldSendCallback: (data) => {
        // Google Tag Manager buggy code (not maintained by us)
        if (data.exception && data.exception.values && data.exception.values[0]) {
          const value = data.exception.values[0].value;
          if (value && /_cc11509/.test(value)) {
            return false;
          }
        }
        // Silences sentries for crawlers/prerender.io
        const isPhantomJS = /PhantomJS/.test(window.navigator.userAgent);
        // Silence sentries from Security scanner
        const isSecurityScanner = "Netsparker (Security team)" == window.navigator.userAgent;
        
        return !isPhantomJS && !isSecurityScanner;
      }
    })
    .setRelease(RELEASE_SHA)
    .addPlugin(ngRaven, angular)
    .install();
  modules.unshift(ngRaven.moduleName);
}

module.exports = angular.module('common', modules)
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/module.js
 **/